"use strict";

// Copyright 2018-2020 The MathWorks, Inc.
define(['lit/lit-element/lit-element.bundled'], function (litElementComponents) {
  'use strict'; // Dummy Extend to allow us to patches to LitElement.
  // E.g. Bug fixes
  // If this is in place up-front, no one walking the prototype chain
  // Gets suprised if we need to modify functionality at this level
  // We should also decide whether we need this level of indirection,
  // if we already have "Widget Base"

  class MWLitElement extends litElementComponents.LitElement {}

  return MWLitElement;
});
//# sourceMappingURL=LitElement.js.map
